// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"354":"b87314bd","742":"26e06255","787":"c4e7f8f9"}[chunkId] + ".chunk.js";
};